import { Link } from 'react-router-dom'
import { STATS, ADVANTAGES } from '@/data/site'
import { Icon } from '@/components/Icon'
import { useReveal } from '@/hooks/useReveal'

export function About() {
  const revealRef = useReveal<HTMLDivElement>()

  return (
    <section className="section about" ref={revealRef}>
      <div className="container about-grid">
        <div className="about-content">
          <span className="eyebrow reveal">关于我们</span>
          <h2 className="about-title reveal delay-1">
            专注增值电信，
            <br />
            <span className="gradient-text">合规稳健经营</span>
          </h2>
          <p className="about-desc reveal delay-2">
            镇江灵芝网络科技有限公司成立于 2017 年，位于江苏省镇江市。公司依法经营增值电信业务，
            致力于为企业客户提供合规、可靠的互联网信息服务与技术支持。
          </p>

          <div className="about-values">
            {ADVANTAGES.map((v, i) => (
              <div key={v.title} className={`about-value reveal delay-${(i % 3) + 1}`}>
                <span className="about-value-icon">
                  <Icon name={v.icon as never} size={22} />
                </span>
                <div>
                  <h4>{v.title}</h4>
                  <p>{v.description}</p>
                </div>
              </div>
            ))}
          </div>

          <Link to="/about" className="btn btn-ghost reveal delay-3">
            了解更多关于我们
            <Icon name="arrow" size={16} />
          </Link>
        </div>

        <div className="about-stats reveal delay-2">
          {STATS.map((s) => (
            <div key={s.label} className="about-stat-card">
              <strong>{s.value}</strong>
              <span>{s.label}</span>
            </div>
          ))}
          <div className="about-stats-note">
            <span className="about-stats-pulse" />
            持续为客户创造长期价值
          </div>
        </div>
      </div>
    </section>
  )
}
